import React from "react";
import { Box, styled } from "@mui/material";
import { useRouteMatch } from "react-router-dom";
import {
  GET_NOTIFICATIONS,
  GET_COURSE_TEACHINGS,
  GET_USER_HEADER,
} from "../../../apollo-client/queries";
import PropTypes from "prop-types";
import { useApolloClient, useQuery } from "@apollo/client";
import { useIsMobile } from "../../../hooks/state-checkers/use-is-mobile";
import { useIsListPage } from "../../../hooks/state-checkers/use-is-list-page";
import { NOTIFICATION_SUBSCRIPTION } from "./notifications/subscriptions";
import { NOTIFICATION_TYPES } from "../../../notification-constants";
import { useHeaderProfile } from "../../../hooks/useHeaderProfile";
import { useHeaderNavigation } from "../../../hooks/useHeaderNavigation";
import { HeaderTopSection } from "./HeaderTopSection";
import { HeaderSubSection } from "./HeaderSubSection";
import { CentralNavigationBar } from "./central-navigation-bar";

const landingPageRoutes = [
  "/",
  "/registration",
  "/activate-user",
  "/forgot-password",
  "/password-reset",
];


export const Header = ({
  title,
  university,
  subscriberCount,
  loading = false,
  color,
  backgroundColor = "#fff",
  hideNavigation = false,
  position,
  course,
  props = {},
}) => {
  const {
    data: userData,
    error: getUserError,
    loading: loadingUserData,
    subscribeToMore,
  } = useQuery(GET_USER_HEADER);

  const isLoggedIn = Boolean(localStorage.getItem("token"));
  const match = useRouteMatch();
  const isMobile = useIsMobile();
  const isListPage = useIsListPage();
  const client = useApolloClient();

  // Custom hooks for different concerns
  const profileProps = useHeaderProfile();
  const { goToTeachersPage } = useHeaderNavigation(course);

  // Set up notification subscription
  React.useEffect(() => {
    if (subscribeToMore) {
      subscribeToMore({
        document: NOTIFICATION_SUBSCRIPTION,
        updateQuery: (prev, { subscriptionData }) => {
          if (
            subscriptionData?.data?.newNotification
              ?.notificationType === NOTIFICATION_TYPES.NEW_TEACHING
          ) {
            client.refetchQueries({
              include: [GET_COURSE_TEACHINGS],
            });
          }

          client.refetchQueries({
            include: [GET_USER_HEADER, GET_NOTIFICATIONS],
          });
        },
      });
    }
  }, [subscribeToMore, client]);

  const isOnLandingPage = landingPageRoutes.includes(match.path);

  return (
    <HeaderContainer>
      <HeaderTopSection
        isOnLandingPage={isOnLandingPage}
        hideNavigation={hideNavigation}
        isLoggedIn={isLoggedIn}
        loadingUserData={loadingUserData}
        getUserError={getUserError}
        userData={userData}
        profileProps={profileProps}
        position={position}
        props={props}
      />

      <HeaderSubSection
        title={title}
        university={university}
        subscriberCount={subscriberCount}
        loading={loading}
        isListPage={isListPage}
        isMobile={isMobile}
        loadingUserData={loadingUserData}
        goToTeachersPage={goToTeachersPage}
        props={props}
      />
    </HeaderContainer>
  );
};

Header.propTypes = {
  title: PropTypes.string,
  university: PropTypes.string,
  subscriberCount: PropTypes.number,
  loading: PropTypes.bool,
  color: PropTypes.string,
  backgroundColor: PropTypes.string,
  hideNavigation: PropTypes.bool,
  position: PropTypes.string,
  course: PropTypes.object,
  props: PropTypes.object,
};

// Main container styled component
const HeaderContainer = styled(Box)({
  display: "flex",
  flexDirection: "column",
  maxWidth: "100vw",
});
